"use strict";
/**
 * This code is from
 * https://github.com/trojanowski/react-apollo-hooks/blob/master/src/index.js
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ApolloContext_1 = __importDefault(require("./ApolloContext"));
const react_1 = require("react");
const getClient_1 = __importDefault(require("./getClient"));
function useClient(clientName) {
    const clients = react_1.useContext(ApolloContext_1.default);
    return getClient_1.default(clients, clientName);
}
exports.default = useClient;
